import { render, staticRenderFns } from "./InstallPrompt.vue?vue&type=template&id=246ac0a6&"
import script from "./InstallPrompt.vue?vue&type=script&lang=js&"
export * from "./InstallPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports